export function calculatePasswordStrength(passwordInput: string): number {
    // Define regular expressions for each category
    const password = passwordInput.trim();
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const numberRegex = /[0-9]/;
    const specialCharRegex = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;

    // Check how many categories the password satisfies
    let fulfilledCategories = 0;

    if (uppercaseRegex.test(password)) {
        fulfilledCategories++;
    }
    if (lowercaseRegex.test(password)) {
        fulfilledCategories++;
    }
    if (numberRegex.test(password)) {
        fulfilledCategories++;
    }
    if (specialCharRegex.test(password)) {
        fulfilledCategories++;
    }

    // Calculate length score (max 60 points)
    const lengthScore = Math.min(password.length * 5, 60);

    // Calculate category score (max 30 points - 10 points per category)
    const categoryScore = Math.min(fulfilledCategories * 10, 30);

    // Return total score (max 100 points)
    return Math.round(((lengthScore + categoryScore) / 90) * 100);
}
